import { Avatar, AvatarFallback, AvatarImage, Button } from '@quadminds/mindkit';
import { LoaderCircle, Plug } from 'lucide-react';
import { FC } from 'react';

interface AvailableConectionProps {
    id: string;
    title: string;
    subtitle: string;
    description: string;
    image?: string;
    onConnect: () => void;
    isConnected?: boolean;
    isLoading?: boolean;
}

const AvailableConection: FC<AvailableConectionProps> = ({
    image,
    title,
    subtitle,
    description,
    onConnect,
    isConnected,
    isLoading,
}) => {
    return (
        <div className="flex flex-col justify-start items-start gap-4 rounded-[8px] bg-[#263238] p-4 w-[268px] h-[160px]">
            <div className="flex">
                <Avatar className="h-[34px] w-[34px] rounded-[4px] mr-2">
                    <AvatarImage
                        className="h-[34px] w-[34px] rounded-[4px] object-contain"
                        src={image}
                        alt="connection Avatar"
                    />
                    <AvatarFallback className="!rounded">
                        <Plug />
                    </AvatarFallback>
                </Avatar>
                <div>
                    <p className="font-poppins font-medium text-[14px] leading-[20px] text-white">{title}</p>
                    <p className="font-roboto font-normal text-[12px] leading-[14px] text-[#B0BEC5]">{subtitle}</p>
                </div>
            </div>
            <p className="font-roboto text-[12px] leading-[14px] text-white font-normal">{description}</p>
            {isConnected !== undefined && (
                <Button onClick={onConnect} className="w-full" variant={isConnected ? 'secondary' : 'default'}>
                    {isLoading ? (
                        <LoaderCircle className="animate-spin h-5" />
                    ) : isConnected ? (
                        'Desactivar'
                    ) : (
                        'Conectar'
                    )}
                </Button>
            )}
        </div>
    );
};

export default AvailableConection;
